import styles from "../AddAgent.module.scss";
import { Heading } from "@netapp/bxp-design-system-react";

export const Container = ({children, style}) => {
    return <div className={styles['step']} style={style}>
        {children}
    </div>
}

export const Title = ({children, style}) => {
    return <Heading center style={{marginBottom: 47, ...style}} nowrap bold color="text-title">{children}</Heading>
}

export const TwoColumn = ({children}) => {
    return <div className={styles['form-col-2']}>{children}</div>
}

export const ColumnHeader = ({children}) => {
    return <Heading level={3} className={styles['tag-input-margin-bottom']}>{children}</Heading>
}
